/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalDialog } from "react-bootstrap-3";

const Dialog = props => (
  <div className="witadmin-bs3" tabIndex={props.tabIndex}>
    <ModalDialog {...props} />
  </div>
);

function FormModal({ children, isOpen, onClose, nestedTitle, minHeight }) {
  return (
    <Modal
      dialogComponentClass={Dialog}
      backdropClassName="witadmin-bs3-backdrop"
      show={isOpen}
      bsSize="large"
      backdrop>
      <Modal.Header>
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">×</span>
          <span className="sr-only">Close</span>
        </button>
        <Modal.Title>{nestedTitle}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={minHeight ? { minHeight: `${minHeight}px` } : undefined}>
        <div>{children}</div>
      </Modal.Body>
    </Modal>
  );
}

FormModal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  nestedTitle: PropTypes.string,
  minHeight: PropTypes.number,
};

export default FormModal;
